export default "__VITE_ASSET__DGC6L0RJ__"